import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { StorageService } from '../storage/storage.service';
import { PwaService } from '../pwa/pwa.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class InsightService {

  constructor(private deviceDetectorService: DeviceDetectorService, private apiService: ApiService, private storageService: StorageService, private pwaService: PwaService) { }

  /**
   * Send a request to store insight information
   * @param data data to be sent
   */
  send(data: {event: string, event_name: string, element?: string}): void {
    if (typeof window == 'undefined') //window is not defined, SSR
      return;

    const date = new Date();
    const now = date.getFullYear() + "-" +
      ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
      ("00" + date.getDate()).slice(-2) + " " +
      ("00" + date.getHours()).slice(-2) + ":" +
      ("00" + date.getMinutes()).slice(-2) + ":" +
      ("00" + date.getSeconds()).slice(-2);

    this.pwaService.getUserUID().subscribe({
      next: (uid) => {
        let payload = {
          ...data,
          registered_at: now,
          page_link: window?.location.href,
          page_title: document.title,
          platform: this.deviceDetectorService.os,
          appkey: this.storageService.getAppKey(),
          uid: uid,
        }

        this.apiService.sendInsight(payload).subscribe({
          //next: () => console.info("Sent insight", payload),
          error: (err: any) => console.error(err)
        });
      },
      error: (err) => console.error(err)
    });
  }
}
